<template>
  <div id="index">
    <Header />
    <div class="mainContent">
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Footer from "@/components/footer/footer";
export default {
  props: {},
  data() {
    return {
      isOpacity: false,
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.path == "/") {
      this.$router.push("/home");
    }
  },
  watch: {
  },
  methods: {},
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped lang="scss">
#index {
  
}
</style>

